import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface Attribute {
  id: string;
  attributeName: string;
  schemaName: string;
  checked: boolean;
}

export interface SelectLeadAttributesModalState {
  attributes: Record<string, Attribute>;
  searchText: string;
}

const initialState: SelectLeadAttributesModalState = {
  attributes: {},
  searchText: '',
};

export const selectLeadAttributesModalSlice = createSlice({
  name: 'listDetail/selectLeadAttributesModal',
  initialState,
  reducers: {
    setAttributes: (state, action: PayloadAction<Attribute[]>) => {
      const attributes = action.payload.reduce((acc, attribute) => {
        acc[attribute.id] = attribute;
        return acc;
      }, {} as Record<string, Attribute>);
      state.attributes = attributes;
    },
    toggleAttributeChecked: (state, action: PayloadAction<Attribute['id']>) => {
      const attribute = state.attributes[action.payload];
      if (attribute) {
        attribute.checked = !attribute.checked;
      }
    },
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
    },
  },
});

export const {
  setAttributes,
  toggleAttributeChecked,
  setSearchText,
} = selectLeadAttributesModalSlice.actions;

export default selectLeadAttributesModalSlice.reducer;
